import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import "./pilaresTecnologicos.scss"
import {
    FaRobot,
    FaChartLine,
    FaCogs,
    FaLightbulb
} from 'react-icons/fa';

const PilaresTecnologicos = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    const pilaresTecnologicos = [
        {
            id: 1,
            titleKey: "idi.pillars.p1Title",
            descKey: "idi.pillars.p1Desc",
            icon: <FaRobot />
        },
        {
            id: 2,
            titleKey: "idi.pillars.p2Title",
            descKey: "idi.pillars.p2Desc",
            icon: <FaChartLine />
        },
        {
            id: 3,
            titleKey: "idi.pillars.p3Title",
            descKey: "idi.pillars.p3Desc",
            icon: <FaCogs />
        },
        {
            id: 4,
            titleKey: "idi.pillars.p4Title",
            descKey: "idi.pillars.p4Desc",
            icon: <FaLightbulb />
        }
    ];

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    return (
        <div className="pilares-info">

            <section className="pilares-info__section">
                <div className="pilares-info__content">
                    <h1 className="pilares-info__title ">{t('idi.pillars.title')}</h1>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <div
                        className="pilares-info__text "
                    >
                        <p className='pilares-info__text-paragraph content__text-title-backgroundWhite'>
                            {t('idi.pillars.lead')}
                        </p>
                    </div>
                </div>
                <div className="pilares-info__cards">
                    {pilaresTecnologicos.map(pilar => (
                        <div key={pilar.id} className="pilar-card">
                            <div className="pilar-card__logo">
                                <span className="pilar-card__icon">{pilar.icon}</span>
                            </div>
                            <h3 className="pilar-card__title">{t(pilar.titleKey)}</h3>
                            <p className="pilar-card__description">{t(pilar.descKey)}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}

export default PilaresTecnologicos;